/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import Hero from "../../components/hero/Hero";
import Pagination from "../../components/pagination/Pagination";
import "./doctor.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDoctors,
  getDoctorsCount,
} from "../../redux/apiCalls/doctorsApiCalls";
import DoctorItem from "../../components/docotors-components/DoctorItem";
import { BsSearch } from "react-icons/bs";

const POST_PER_PAGE = 100;

const Doctor = () => {
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const { doctorsCount, doctors } = useSelector((state) => state.doctor);
  const pages = Math.ceil(doctorsCount / POST_PER_PAGE);

  const dispatch = useDispatch();

  const generatedPages = [];
  for (let i = 1; i <= pages; i++) {
    generatedPages.push(i);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchDoctors(currentPage));
  }, [currentPage]);

  useEffect(() => {
    dispatch(getDoctorsCount());
  }, []);

  return (
    <div className="doctor-page">
      <Hero
        pageTitle="بيانات جميع الاطباء"
        pageDiscription="بيانات جميع الاطباء فى كافة التخصصات بمحافظة اسيوط"
      />
      <div className="serch-container">
        <input
          type="text"
          placeholder="بحث .. بالاسم - المدينة - التخصص ..."
          onChange={(e) => setQuery(e.target.value)}
        />
        <BsSearch className="search-icon" />
      </div>

      <div className="doctors-list-wrapper">
        <div className="doctor-list-doctorpage">
          {doctors
            ?.filter(
              (doctor) =>
                doctor.name.toLowerCase().includes(query) ||
                doctor.city.toLowerCase().includes(query) ||
                doctor.department.toLowerCase().includes(query)
            )
            .map((doctor) => (
              <DoctorItem doctor={doctor} key={doctor._id} />
            ))}
        </div>
      </div>
      <div className="doctor">
        <Pagination
          pages={pages}
          doctors={doctors}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default Doctor;
